import React, { useEffect, useState } from "react";
import AboutArea from "../../components/About/AboutArea";
import BannerOne from "../../components/Banner/BannerOne";
import BlogArea from "../../components/Blog/BlogArea";
import ConsultationArea from "../../components/Consultation/ConsultationArea";
import NewsLetterArea from "../../components/NewsLetter/NewsLetterArea";
import ProjectArea from "../../components/Project/ProjectArea";
import ServicesArea from "../../components/ServicesArea/ServicesArea";
import TeamArea from "../../components/Team/TeamArea";
import TestimonialArea from "../../components/Testimonial/TestimonialArea";
import Layout from "../../layouts/Layout";
import { Helmet } from "react-helmet";

const CreativeAgency = () => {


  return (
    <>
      <Helmet>
        <title>The Digital Creative Designs: Creative Design Agency in USA</title>
        <meta
          name="description"
          content="The Digital Creative Designs is a creative design agency in USA. Our team of graphic designers specializes in graphic design services across US. Visit us now!"
        />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="author" content="The Digital Creative Designs US" />
        <meta
          property="og:title"
          content="The Digital Creative Designs: Creative Design Agency in USA"
        />
        <meta
          property="og:description"
          content="The Digital Creative Designs is a creative design agency in USA. Our team of graphic designers specializes in graphic design services across US. Visit us now!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="The Digital Creative Designs US" />
        <meta property="og:url" content="https://thedigitalcreativedesigns.com/" />
        <meta
          property="og:image"
          content="https://thedigitalcreativedesigns.com/img/logo-1.webp"
        />

        <link rel="canonical" href="https://thedigitalcreativedesigns.com/" />
      </Helmet>
      <Layout header={1} footer={1}>
        <BannerOne />
        <ServicesArea />
        <AboutArea />
        <TeamArea />
        <ProjectArea />
        <TestimonialArea />
        <ConsultationArea />
        {/* <BlogArea /> */}
        <NewsLetterArea />
      </Layout>
    </>
  );
};

export default CreativeAgency;
